import React from 'react';

export default function CheckmarkIcon() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'lightgreen' }} // CSS-fargen du ønsker
    >
      <path
        d="M20 6L9 17L4 12"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}